function loadGoogleMaps(callbackFunctionName) {
    if (!(typeof google === 'object' && typeof google.maps === 'object') && googleMapsUrl !== undefined) {
        if (callbackFunctionName !== undefined) {
            googleMapsUrl += '&callback=' + callbackFunctionName;
        }

        var googleMapsScript = document.createElement('script');
        googleMapsScript.type = 'text/javascript';
        googleMapsScript.src = googleMapsUrl;
        googleMapsScript.async = false;
        googleMapsScript.defer = false;

        var node = document.getElementsByTagName('script')[0];
        node.parentNode.insertBefore(googleMapsScript, node);
    }
}